// extracted by mini-css-extract-plugin
export default {"container":"select_container__LMSY8","select":"select_select__TCSNR","error":"select_error__NHR4p","asterisk":"select_asterisk__Nd4Yy"};